module.exports = __webpack_public_path__ + "static/media/Imageicon.85269bbd.svg";